import React, { useState, useEffect } from "react";
import { MDBRow, MDBCol, MDBInput, MDBBtn, MDBContainer } from "mdbreact";

import Axios from "axios";

import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import WarningBox from "../components/WarningBox";

import { Bounce, ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import Spinner from "../components/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCheck,
  faHourglassHalf,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
const AddEditAppointmentCustomerView = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [showPreloader, setPreloader] = useState("normal");

  const [frm, setValues] = useState({
    code: "new",
    targetdate: new Date(),
    approveddatetime: new Date(),
    appointmentstatus: { value: "0", label: "PENDING CONFIRMATION" },
    requestdetails: "Preventive Maintenance",
    usertoken: sessionStorage.getItem("msal.uc"),
  });
  const toastId = React.useRef(null);

  const notify = (message) => {
    toast(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold blue-text",
    });
  };

  const warning = (message) => {
    toast.error(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold white-text",
    });
  };

  const getDateValue = (dtPickerName) => (actualValue) => {
    setValues({ ...frm, [dtPickerName]: actualValue });
  };

  const [appointmentstatusoptions, setappointmentstatusoptions] = useState([]);
  const loadappointmentstatusoption = () => {
    Axios.get(serverURL + "/getappointmentstatusoptions", bearer)
      .then((res) => {
        setappointmentstatusoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    saveappointment();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const loadappointmentdetails = () => {
    setPreloader("normal");
    Axios.get(
      props.apiServer + "/loadappointmentdetails?acode=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.code,

            appointmentstatus: {
              value: res.data.appointmentstatuscode,
              label: res.data.appointmentstatus,
            },

            targetdate: new Date(res.data.targetdate),
            approveddatetime: new Date(res.data.approveddatetime),
            appointmentstatus: {
              value: res.data.appointmentstatuscode,
              label: res.data.appointmentstatus,
            },
            requestdetails: res.data.requestdetails,
          });
          setPreloader("none");
        } else {
          // console.log("No record");
          setPreloader("none");
        }
      })

      .catch((error) => {
        // setErrorMessage(error);
        warning("Failed to load record.");
      });
    // setPreloader("none");
  };

  const saveappointment = () => {
    const data = frm;
    setPreloader("normal");
    Axios.post(props.apiServer + "/savemyappointment", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });
          notify(res.data.message);
          if (props.code === "") {
            props.toggleModal();
          }

          setPreloader("none");
        } else {
          warning(res.data.message);
          setPreloader("none");
        }
      })
      .catch((error) => {
        warning(error);
        setPreloader("none");
      });
  };
  useMountEffect(loadappointmentstatusoption);

  useMountEffect(loadappointmentdetails);

  return (
    <React.Fragment>
      {showPreloader === "normal" ? (
        <Spinner />
      ) : (
        <MDBContainer fluid>
          <MDBRow>
            <MDBCol md="10">
              <form
                className="needs-validation"
                onSubmit={submitHandler}
                noValidate
              >
                <MDBRow hidden>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.code}
                      id="code"
                      label="code"
                      required
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.requestdetails}
                      id="requestdetails"
                      label="Request Details"
                      required
                      onChange={updateField}
                      type="textarea"
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="10">
                    <label className="grey-text">
                      <small>&nbsp;Target Date/Time</small>
                    </label>
                    <br />
                    <DatePicker
                      selected={frm.targetdate}
                      onChange={getDateValue("targetdate")}
                      timeInputLabel="Time:"
                      dateFormat="MM/dd/yyyy h:mm aa"
                      showTimeInput
                    />
                    <br />
                    <br />
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="10" className="text-left">
                    <label className="grey-text">
                      <small>&nbsp;Appointment Status</small>
                    </label>
                    <br />

                    {frm.appointmentstatus.value === "0" ? (
                      <>
                        <span className="font-weight-bold red-text small">
                          <FontAwesomeIcon icon={faHourglassHalf} />{" "}
                          {frm.appointmentstatus.label}
                        </span>
                      </>
                    ) : frm.appointmentstatus.value === "1" ? (
                      <>
                        <span className="font-weight-bold blue-text small">
                          <FontAwesomeIcon icon={faCheck} />{" "}
                          {frm.appointmentstatus.label}
                        </span>
                      </>
                    ) : frm.appointmentstatus.value === "2" ? (
                      <>
                        <span className="font-weight-bold dark-grey-text small">
                          <FontAwesomeIcon icon={faRotateLeft} />{" "}
                          {frm.appointmentstatus.label}
                        </span>
                      </>
                    ) : (
                      <>
                        <span className="font-weight-bold grey-text small">
                          <FontAwesomeIcon icon={faBan} />{" "}
                          {frm.appointmentstatus.label}
                        </span>
                      </>
                    )}

                    <br />
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md="12">
                    <MDBBtn className="blue lighten-1" type="submit">
                      Save
                    </MDBBtn>

                    {props.code === "" ? (
                      <>
                        <MDBBtn
                          id="cmdClose"
                          className="blue lighten-4 blue-text"
                          onClick={props.toggleModal}
                        >
                          Close this
                        </MDBBtn>
                      </>
                    ) : (
                      ""
                    )}
                  </MDBCol>
                  <MDBCol md="6"></MDBCol>
                </MDBRow>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      ></ToastContainer>
      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditAppointmentCustomerView;
